const no = {
  'order-cake': 'bestill-kake'
};

const se = {
  'order-cake': 'beställa-tårta'
};

export const APP_ROUTES = {
  no,
  se,
  GIFT_CARDS: 'gavekort'
};

export const CURRENT_LANG_APP_ROUTES = {
  CATEGORY: {
    en: 'category',
    no: 'kategori',
    se: 'kategori'
  },
  PRODUCT: {
    en: 'product',
    no: 'produkt',
    se: 'produkt'
  },
  B2B: {
    en: 'business',
    no: 'bedrift',
    se: 'foretag'
  }
};

